
import { Component, Watch, Prop } from 'vue-property-decorator';
import Report from '@/components/Report';
import { PivotDataModel } from '@/models/pivot_data';
import ChatWithUs from '@/components/ChatWithUs.vue';
import LoadingSlider from '@/components/LoadingSlider.vue';
import ContentLoadResultMessage from '@/components/ContentLoadResultMessage.vue';
import DrilldownTableReport from '@/components/DrilldownTableReport.vue';
import { DimensionModel } from '@/models/dimension';
import { FilterColumnList } from '@/collections/filter_columns';
import { FilterColumnModel } from '@/models/filter_column';
import { EventHandler } from '@/modules/events';
import { StoreModel } from '@/models/store';
import FeatureLockedNotify from '@/components/FeatureLockedNotify.vue';
import { RuleModel } from '@/models/rule';
import FilterColumn from '@/components/FilterColumn.vue';
import Selector from '@/components/OptionSelector.vue';
import dateFormat from 'dateformat';
import Alert from '@/components/Alert.vue';
import { EventBus } from '@/main';
import { postUnlockReviewService } from '@/services/PostUnlockReviewService';
import { TemplateReportList } from '@/collections/template_reports';
import ActionButton from '@/components/ActionButton.vue';
import DTotal from '@/components/DTotal.vue';
import { MeasureList } from '@/collections/measures';
import GoogleDriveSelector from '@/components/GoogleDriveSelector.vue';
import ProductSegmentDialog from '@/components/ProductSegmentDialog.vue';
import RowDetailsDialog from '@/components/RowDetailsDialog.vue';
import DownloadFullData from '@/components/DownloadFullData.vue';
import { RelatedLinkList } from '@/collections/related_links';
import { ReportModel } from '@/models/report';
import { ColorRuleList } from '@/collections/color_rules';
import { compositionConfig, getAvailableCompositionKeys, CompositionDefinition } from '@/config/compositionConfig';
// IMPORT CURRENCY HELPER
import { CurrencyHelper } from '@/helpers/CurrencyHelper';
// IMPORT NEW RENDERER
import CompositionCellRenderer from './CompositionCellRenderer.vue';

// Declare global objects
declare const gapi: any;
declare const google: any;

interface Option {
  sortBy?: any;
  sortDesc?: any;
  page?: number;
  itemsPerPage?: number;
  multiSort?: boolean;
}

// --- START Interface Modification --- 
interface Header {
  text?: string;
  value: string;
  class?: string | string[];
  cellClass?: string | string[];
  sortable?: boolean;
  filterable?: boolean;
  description?: string;
  colorIndex?: boolean;
  width?: string;
  align?: string;
  dataType?: string;
  isPin?: boolean;
  left?: number;
  dynamicConfig?: CompositionDefinition; // Added for dynamic pivot groups
}
// --- END Interface Modification --- 

@Component({
  components: {
    ChatWithUs,
    LoadingSlider,
    ContentLoadResultMessage,
    DrilldownTableReport,
    FeatureLockedNotify,
    FilterColumn,
    Selector,
    Alert,
    ActionButton,
    DTotal,
    GoogleDriveSelector,
    ProductSegmentDialog,
    RowDetailsDialog,
    DownloadFullData,
    CompositionCellRenderer, // Ensure it's registered
  },
})
export default class TableReport extends Report {
  @Prop({ default: false })
  public isBasicTable!: boolean;

  // Make CurrencyHelper available in the template
  public CurrencyHelper = CurrencyHelper;

  // ADD TABLE VIEW MODE PROP HERE
  @Prop({ type: String, required: true }) public tableViewMode!: string;

  public get getTableHeight() {
    let tableHeight = document.documentElement.clientHeight;
    /* if (tableHeight < 700) { */
    /*   return tableHeight + 300; */
    /*   /1* return 'auto'; *1/ */
    /* } */

    return tableHeight;
  }

  public get dateRangeText() {
    return `${dateFormat(this.filterTimerange[0], 'mmm d, yyyy', true)} - ${dateFormat(this.filterTimerange[1], 'mmm d, yyyy', true)}`;
  }

  public get reportHeight() {
    let rowCount = this.report.rows.length;
    return rowCount * 100;
  }

  @Prop({ default: () => new StoreModel() })
  public store!: StoreModel;
  public typeReport: string = 'TABLE';
  public headers: Header[] = this.isBasicTable ? [] : [
    {
      text: 'Actions',
      value: 'actions',
      class: 'table-header',
      cellClass: 'table-item font-weight-regular',
      sortable: false,
      align: 'center d-print-none',
      isPin: true,
      left: 0
    }
  ];
  public rows: any = [];
  public dialogPivot: boolean = false;
  public dialogReportWrongData: boolean = false;
  public wrongDataMessage: string = '';
  public pivotTable: PivotDataModel = new PivotDataModel();
  public pivotTableData: any[] = [];
  public pivotTableHeader: any[] = [];
  @Prop({default: {}})
  public initOptions!: Option;
  public options: Option = {};
  public tableLoading: boolean = false;
  public enablePivot: boolean = false;
  public fisrtTimeInitOption: boolean = true;
  public columnNames: any = {
    productName: 'Item[Item Description]',
  };
  public error: boolean = false;
  @Prop({ default: [] })
  public filterReportColumns!: any;
  @Prop({ default: [] })
  public selectedReportColumns!: any;
  @Prop({default: () => new MeasureList()})
  public measures!: MeasureList;
  public loadingSlides: string[] = [
    'Connecting to analytic services',
    'Fetching data',
    'Building report',
    'Downloading data',
    'Generating datatable',
  ];
  public notEmptyRules: any = [
    this.isNameExist,
  ];
  public needCount: boolean = true;
  public isResetOptions: boolean = false;
  public dialogDrilldown: boolean = false;
  public dialogDrilldownDatatable: boolean = false;
  public drilldownItem: any = {};
  public drilldownDimension: any = '';
  public drilldownFilterColumns: FilterColumnList = new FilterColumnList();
  public selectedFilterColumn: FilterColumnModel = new FilterColumnModel();
  public selectedDrilldownDimension: DimensionModel = new DimensionModel();
  public selectedCellItem: any;
  public rule: RuleModel = new RuleModel({ code: 'tracked_metrics_count' });
  public popularDimensions: any = [];
  public selectingDimensions: any = [];
  public itemFilterPosition: string = '';
  public showItemFilterMenu: boolean = false;
  public menuX: number = 0;
  public menuY: number = 0;
  public headerMenuY: number = 0;
  public headerMenuX: number = 0;
  public showHeaderOptionMenu: boolean = false;
  public selectingFilterValue: any = { columnCode: '', item: {} };
  public selectingFilterItem: any = {};
  public downloadFileExt: string = 'csv';
  public operatorButtons: any = {
    textOperators: [
      {
        value: 'eq',
        icon: 'mdi-equal',
      },
      {
        value: 'ne',
        icon: 'mdi-not-equal-variant',
      },
      {
        value: 'contains',
        icon: 'mdi-contain',
      },
    ],
    numberOperators: [
      {
        value: 'eq',
        icon: 'mdi-equal',
      },
      {
        value: 'ne',
        icon: 'mdi-not-equal-variant',
      },
      {
        value: 'gt',
        icon: 'mdi-greater-than',
      },
      {
        value: 'lt',
        icon: 'mdi-less-than',
      },
    ],
  };
  public itemTooltipMenu: boolean = false;
  public selectingDrilldownDashboardAction: any = {};
  public drilldownDashboardActions: any = {
    'Vendor Name': {
      report: '/dashboard/vendor',
      label: 'Vendor Detailed Dashboard',
      filterCode: 'Vendor Name',
      idParam: '',
    },
    'Location[Location]': {
      report: '/dashboard/store',
      label: 'Product Detailed Dashboard',
      filterCode: 'Location[Location]',
      idParam: '',
    },
    'Item[Item Description]': {
      report: '/dashboard/product',
      label: 'Product Detailed Dashboard',
      filterCode: 'Item[Item Description]',
      idParam: 'product_id',
    },
    'Item[Item Category]': {
      report: '/dashboard/collection',
      label: 'Collection Detailed Dashboard',
      filterCode: 'Item[Item Category]',
      idParam: '',
    },
  };
  public breakdownDimensionTree: any = [
    {
      dimension: {
        name: 'Product',
        code: 'by_product',
        columnCode: 'Item[Item Description]',
        filterCode: 'Item[Item Description]',
      },
      childDimension: [
        {
          name: 'Variant',
          code: 'by_variant',
          columnCode: 'variant',
        },
      ],
    },
    {
      dimension: {
        name: 'Vendor',
        code: 'by_vendor',
        columnCode: 'Vendor Name',
        filterCode: 'Vendor Name',
      },
      childDimension: [
        {
          name: 'Product',
          code: 'by_product',
          columnCode: 'Item[Item Description]',
        },
        {
          name: 'Variant',
          code: 'by_variant',
          columnCode: 'variant',
        },
      ],
    },
    {
      dimension: {
        name: 'Store Location',
        code: 'by_location',
        columnCode: 'Location[Location]',
        filterCode: 'Location[Location]',
      },
      childDimension: [
        {
          name: 'Collection',
          code: 'by_category',
          columnCode: 'Item[Item Category]',
        },
        {
          name: 'Product',
          code: 'by_product',
          columnCode: 'Item[Item Description]',
        },
        {
          name: 'Variant',
          code: 'by_variant',
          columnCode: 'variant',
        },
      ],
    },
    {
      dimension: {
        name: 'Collection',
        code: 'by_category',
        columnCode: 'Item[Item Category]',
        filterCode: 'product_collections',
      },
      childDimension: [
        {
          name: 'Product',
          code: 'by_product',
          columnCode: 'Item[Item Description]',
        },
        {
          name: 'Variant',
          code: 'by_variant',
          columnCode: 'variant',
        },
      ],
    },
    {
      dimension: {
        name: 'Sales Channel',
        code: 'sales_channel_name',
        columnCode: 'sales_channel_name',
        filterCode: 'sales_channel_name',
      },
      childDimension: [
        {
          name: 'Collection',
          code: 'by_category',
          columnCode: 'Item[Item Category]',
        },
        {
          name: 'Product Type',
          code: 'by_product_type',
          columnCode: 'product_type',
        },
        {
          name: 'Product',
          code: 'by_product',
          columnCode: 'Item[Item Description]',
        },
        {
          name: 'Variant',
          code: 'by_variant',
          columnCode: 'variant',
        },
      ],
    },
    {
      dimension: {
        name: 'Product Type',
        code: 'by_product_type',
        columnCode: 'product_type',
        filterCode: 'product_type',
      },
      childDimension: [
        {
          name: 'Product',
          code: 'by_product',
          columnCode: 'Item[Item Description]',
        },
        {
          name: 'Variant',
          code: 'by_variant',
          columnCode: 'variant',
        },
      ],
    },
  ];
  public selectingBreakdownTreeItem: any = {};
  @Prop({ default: () => new TemplateReportList() })
  public templateReports!: TemplateReportList;
  public selectedDrilldownReportColumns: any = [];
  public fullscreenTable: boolean = false;
  public datatableClass: string = '';
  public isCopied: boolean = false;
  @Prop({default: false})
  public canCreateViewForTemplateReport!: boolean;
  public downloadDialog: boolean = false;
  public downloadReportName: string = '';
  public generatePurchaseOrderDialog: boolean = false;
  public relatedLinks: RelatedLinkList = new RelatedLinkList();
  public loadingRelatedLinks: boolean = false;
  public maxPinColumn: number = 3;
  public isPinnedColumn: boolean = true;
  public enableMultipleSort: boolean = false;
  @Prop({ default: () => new ColorRuleList() })
  public colorRules!: ColorRuleList;
  @Prop({ default: 3 })
  public pinColumnCount!: number;
  private showColumnHint: boolean = false;
  public showFormulaExplanation: boolean = false;
  public selectedExplanationItem: any = null;

  // --- ADD THIS FLAG --- 
  private isPinning: boolean = false;
  // --- END ADDITION ---

  // --- ADDITIONS FOR DTotal Offset Prop ---
  public dTotalOffsets: { [index: number]: string } = {}; // New reactive property
  // --- END ADDITIONS ---

  // --- ADDITIONS FOR PHASE 4 ---
  private debouncedUpdateOffsets: Function = () => {}; // Placeholder for debounced function
  // --- END ADDITIONS ---

  // --- Add new property for dynamic config ---
  private additionalInfoColumn: CompositionDefinition | null = null;
  // --- End new property ---

  public async created() {
    EventBus.$on('show-download-dialog', async (data?: { reportName?: string }) => {
      this.downloadReportName = data?.reportName || '';
      this.downloadDialog = true;
    });

    EventBus.$on('show-generate-po-dialog', async () => {
      this.generatePurchaseOrderDialog = true;
    });
    for (const rule of this.store.currentPackage.rules.items) {
      if (rule.code === this.rule.code) {
        this.rule = rule;
        break;
      }
    }
    this.report.typeReport = this.typeReport;
    this.report.isDetail = this.isDetail;
    if (this.measure.dimensions.items.length > 0) {
      this.drilldownDimension = this.measure.dimensions.items[0].code;
    }
    this.report.pivotOption = this.pivotOption;
    this.initPopularDimensions();

    // Show column hint after a short delay if user hasn't seen it before
    const hasSeenColumnHint = localStorage.getItem('has_seen_column_hint');
    if (!hasSeenColumnHint) {
      setTimeout(() => {
        this.showColumnHint = true;
        localStorage.setItem('has_seen_column_hint', 'true');
      }, 2000);
    }
  }

  public getShortColumnName(header: any, hover: boolean = false, max: number = 29) { // Adjusted default max slightly
    const columnName = header.text;
    if (!columnName || columnName === 'undefined' || columnName === undefined || columnName === 'null') return '';
    const len = columnName.length;
    const hasSort: boolean = this.showSortArrow(header.value, false) || this.showSortArrow(header.value, true);
    // REMOVE THIS BLOCK:
    /*
    if (hover) {
      max = max - 3;
    }
    */
    if (hasSort) {
      // Adjust max based *only* on sort icon presence, not hover
      max = max - 3; // Or adjust as needed based on icon widths
    }
    let substr = columnName.substring(0, max);
    if (len > max) {
      substr = substr + '..';
    }
    return substr;
  }

  public get isAbleToChangeColumnName() {
    return this.$route.name === 'customReport';
  }

  public turnFullscreenTable() {
    this.fullscreenTable = !this.fullscreenTable;
    if (this.fullscreenTable) {
      this.datatableClass = 'datatable_scroll';
    } else {
      this.datatableClass = '';
    }
    if (this.fullscreenTable) {
      this.sendMixPanelEvent('resize fullscreen table');
    }
    this.$emit('turn-fullscreen-table', this.fullscreenTable);
  }

  public reloadData() {
    EventBus.$emit('reload-report-data');
  }

  public isNoPrintColumn(header: any) {
    if (header.value === 'actions' || header.value === 'image') {
      return true;
    }
    return false;
  }

  public hasBreakdownChild(childDimension: any) {
    if (childDimension) {
      for (const child of childDimension) {
        if (this.canDrilldownDimension(child.code)) {
          return true;
        }
      }
    }
    return false;
  }

  public getSelectingBreakdownTreeItem() {
    for (const item of this.breakdownDimensionTree) {
      if (item.dimension.columnCode === this.selectingFilterValue.columnCode) {
        this.selectingBreakdownTreeItem = item;
      }
    }
  }

  public getChildBreakdownLink(childDimension: any) {
    if (!this.canDrilldownDimension(childDimension.code)) {
      return '#';
    }
    let link = `/reports/measures/${this.measure.code}`;
    link = link + '?dimension=' + childDimension.code;
    if (this.analyticsType.code && this.analyticsType.code !== undefined) {
      link = link + '&analytic=' + this.analyticsType.code;
    }
    if (this.filterTimerange && this.filterTimerange.length >= 2) {
      link = link + '&start_time=' + this.filterTimerange[0];
      link = link + '&end_time=' + this.filterTimerange[1];
    }
    const filterParams = [];
    const currentItemFilterValue = this.getCurrentItemFilterValue();
    filterParams.push(currentItemFilterValue);
    if (this.filterColumns && this.filterColumns.items.length > 0) {
      for (const item of this.filterColumns.items) {
        filterParams.push(`${item.name}__${item.code}__${item.operator}__${item.value.join('_or_')}__${item.dataType}`);
      }
    }
    link = link + '&filter=' + filterParams.join('_col_');

    if (this.pivotOption && this.pivotOption !== undefined) {
      link = link + '&pivot_option=' + this.pivotOption;
    }
    if (this.reportParams && this.reportParams.items.length > 0) {
      const params = [];
      for (const item of this.reportParams.items) {
        params.push(`${item.name}__${item.code}__${item.dataType}__${item.valueType}__${item.value.join('_or_')}`);
      }
      if (params.length > 0) {
        link = link + '&params=' + params.join('_param_');
      }
    }
    return link;
  }

  public getCurrentItemFilterValue() {
    const name = this.selectingBreakdownTreeItem.dimension.name;
    const code = this.selectingBreakdownTreeItem.dimension.filterCode;
    const value = this.selectingFilterItem[this.selectingBreakdownTreeItem.dimension.columnCode];
    const operator = 'eq';
    const dataType = 'text';
    return `${name}__${code}__${operator}__${value}__${dataType}`;
  }

  public getDrilldownReportByDimension(columncode: string) {
    const dimensionCode: string = this.getDimensionCode(columncode);
    const shopify_store = localStorage.getItem('shopify_store') || '';
    const storeName = shopify_store.replace('.myshopify.com', '');
    let link = `/reports/measures/${this.measure.code}`;
    link = link + '?dimension=' + dimensionCode;
    if (this.analyticsType.code && this.analyticsType.code !== undefined) {
      link = link + '&analytic=' + this.analyticsType.code;
    }
    if (this.filterTimerange && this.filterTimerange.length >= 2) {
      link = link + '&start_time=' + this.filterTimerange[0];
      link = link + '&end_time=' + this.filterTimerange[1];
    }
    if (this.filterColumns && this.filterColumns.items.length > 0) {
      const filterParams = [];
      for (const item of this.filterColumns.items) {
        filterParams.push(`${item.name}__${item.code}__${item.operator}__${item.value.join('_or_')}__${item.dataType}`);
      }
      if (filterParams.length > 0) {
        link = link + '&filter=' + filterParams.join('_col_');
      }
    }

    if (this.pivotOption && this.pivotOption !== undefined) {
      link = link + '&pivot_option=' + this.pivotOption;
    }
    if (this.reportParams && this.reportParams.items.length > 0) {
      const params = [];
      for (const item of this.reportParams.items) {
        params.push(`${item.name}__${item.code}__${item.dataType}__${item.valueType}__${item.value.join('_or_')}`);
      }
      if (params.length > 0) {
        link = link + '&params=' + params.join('_param_');
      }
    }
    return link;
  }

  public async getRelatedLinks(columnCode: string, item: any) {
    const enableGettingRelatedLinks = [
      'variant',
      'Item[Item Description]',
      'Location[Location]',
      'Document No',
    ]
    this.relatedLinks = new RelatedLinkList();
    if (enableGettingRelatedLinks.includes(columnCode)) {
      const params: any = { code: columnCode, value: item[columnCode] };
      if (columnCode === 'variant') {
        for (const colName in item) {
          if (colName === 'Item[Item Description]') {
            params.extra = item[colName];
            break;
          }
        }
      }
      this.loadingRelatedLinks = true;
      await this.relatedLinks.fetch(params);
      this.loadingRelatedLinks = false;
    }
  }

  public addFilter(operator: string) {
    const item = this.selectingFilterValue.item;
    const columnCode = this.selectingFilterValue.columnCode;
    const filter: FilterColumnModel = new FilterColumnModel();
    filter.code = columnCode;
    filter.dataType = 'number';
    filter.name = this.getSelectingColumnName();
    filter.operator = operator;
    filter.value = [item[columnCode]];
    EventBus.$emit('add-new-filter', filter);
    this.showItemFilterMenu = false;
  }

  public async showFilterOption(columnCode: string, item: any) {
    if (columnCode === 'actions' || columnCode === 'image') {
      this.showItemFilterMenu = false;
      return;
    }
    this.selectingFilterValue = { columnCode, item };
    await this.getRelatedLinks(columnCode, item);
    this.selectingFilterItem = item;
    this.getSelectingBreakdownTreeItem();
  }

  public isActiveSort(header: any, isDesc: boolean = true) {
    if (!this.sortDesc || this.sortDesc.length === 0 || !this.sortBy || this.sortBy.length === 0) {
      return false;
    }
    let isSorted: boolean = false;
    let sortDesc: boolean = false;
    let index: number = 0;
    for (const sortBy of this.sortBy) {
      if (sortBy === header.value) {
        sortDesc = this.sortDesc[index];
        isSorted = true;
        break;
      }
      index++;
    }
    if (isSorted && sortDesc === isDesc) {
      return true;
    }
    return false;
  }

  public getSortIndex(headerCode: string) {
    if (!this.sortDesc || this.sortDesc.length < 2 || !this.sortBy || this.sortBy.length < 2) {
      return 0;
    }
    let index: number = 0;
    for (const sortBy of this.sortBy) {
      if (sortBy === headerCode) {
        return index + 1;
      }
      index++;
    }
    return 0;
  }

  public showSortArrow(headerCode: string, isDesc: boolean = true) {
    if (!this.sortDesc || this.sortDesc.length === 0 || !this.sortBy || this.sortBy.length === 0) {
      return false;
    }
    let isSorted: boolean = false;
    let sortDesc: boolean = false;
    let index: number = 0;
    for (const sortBy of this.sortBy) {
      if (sortBy === headerCode) {
        sortDesc = this.sortDesc[index];
        isSorted = true;
        break;
      }
      index++;
    }
    if (isSorted && sortDesc === isDesc) {
      return true;
    }
    return false;
  }

  public removeHeader(value: string) {
    let removeIndex: number = -1;
    let index: number = -1;
    for (const header of this.headers) {
      index++;
      if (header.value === value) {
        removeIndex = index;
      }
    }
    if (removeIndex !== -1) {
      this.headers.splice(removeIndex, 1);
    }
    this.saveReportHeaders();
  }

  public applySortColumn(header: any, sortDesc: boolean = true) {
    // check if the selecting column is sorted or not
    let isSorted: boolean = false;
    let index: number = 0;
    let isSortDesc: boolean = false;
    if (!this.options.sortBy || this.options.sortBy.length === 0) {
      this.options.sortBy = [];
      this.options.sortDesc = [];
    }
    for (const item of this.options.sortBy) {
      if (item === header.value) {
        isSorted = true;
        isSortDesc = this.options.sortDesc[index];
        break;
      }
      index++;
    }
    if (isSorted && isSortDesc === sortDesc) {
      // remove sort for this columns
      this.options.sortBy.splice(index, 1);
      this.options.sortDesc.splice(index, 1);
    } else if (isSorted && isSortDesc !== sortDesc) {
      // change direction of the sort for this column
      this.options.sortDesc[index] = sortDesc;
    } else {
      // add new sort for this columns
      if (!this.enableMultipleSort) {
        this.options.sortBy = [];
        this.options.sortDesc = [];
      }
      this.options.sortBy.push(header.value);
      this.options.sortDesc.push(sortDesc);
    }
    this.optionChanged();
    this.sendMixPanelEvent(
      'Sort Table Column', {
        columnName: header.text, columnCode: header.value
      }
    );
  }

  public async copyCellValue() {
    const item = this.selectingFilterValue.item;
    const columnCode = this.selectingFilterValue.columnCode;
    const value = item[columnCode];
    this.isCopied = true;
    navigator.clipboard.writeText(value);
    EventBus.$emit('show-snackbar', 'Copied to clipboard');
  }

  public canDrilldownColumn(columnCode: string) {
    const dimensionCode = this.getDimensionCode(columnCode);
    if (this.dimension.code === dimensionCode) {
      return false;
    }
    for (const dimension of this.measure.dimensions.items) {
      if (dimension.code === dimensionCode) {
        return true;
      }
    }
    return false;
  }

  public canDrilldownDimension(dimensionCode: string) {
    if (dimensionCode === this.dimension.code) {
      return false;
    }
    for (const dimension of this.measure.dimensions.items) {
      if (dimension.code === dimensionCode) {
        return true;
      }
    }
    return false;
  }

  public canViewDetailedDashboard(columnCode: string) {
    return Object.keys(this.drilldownDashboardActions).includes(columnCode);
  }

  public getDetailedDashboardLink(column: Header, item: any) {
    const selectingAction = this.drilldownDashboardActions[column.value];

    let link = `${selectingAction.report}?name=${item[selectingAction.filterCode]}`;

    if (selectingAction.idParam && item[selectingAction.idParam] !== undefined) {
      link = `${link}&id=${item[selectingAction.idParam]}`;
    }
    if (this.filterTimerange.length === 3) {
      link = `${link}&start_time=${this.filterTimerange[0]}&end_time=${this.filterTimerange[1]}`;
    }
    return link;
  }

  public getDataTypeByColumnCode(code: string) {
    for (const column of this.report.columns) {
      if (column.code === code) {
        return column.dataType;
      }
    }
    return '';
  }

  public getSelectingColumnName() {
    const columnCode = this.selectingFilterValue.columnCode;
    return this.getColumnNameByColumnCode(columnCode);
  }

  public getColumnNameByColumnCode(code: string) {
    for (const column of this.report.columns) {
      if (column.code === code) {
        return column.name;
      }
    }
    return '';
  }

  public getDimensionCode(columnCode: string) {
    for (const column of this.report.columns) {
      if (column.code === columnCode) {
        return column.luisMapping;
      }
    }
    return '';
  }

  public doNotTranslateRowValue(item: any) {
    return 'notranslate';
  }

  public initPopularDimensions() {
    this.popularDimensions = [
      {
        type: 'Time Period',
        dimensions: [
          { id: 3, name: 'Day', code: 'by_day' },
          { id: 13, name: 'Week', code: 'by_week' },
          { id: 8, name: 'Month', code: 'by_month' },
          { id: 10, name: 'Quarter', code: 'by_quarter' },
          { id: 14, name: 'Year', code: 'by_year' },
        ],
      },
      {
        type: 'Business Object',
        dimensions: [
          { id: 9, name: 'Product', code: 'by_product' },
          { id: 157, name: 'Product Variant', code: 'by_variant' },
          { id: 161, name: 'Product Type', code: 'by_product_type' },
          { id: 2, name: 'Collection', code: 'by_category' },
          { id: 23, name: 'Store Location', code: 'by_location' },
          { id: 245, name: 'Fulfilled Location', code: 'fulfilled_location' },
          { id: 28, name: 'Customer', code: 'by_customer' },
          { id: 85, name: 'Vendor', code: 'by_vendor' },
          { id: 262, name: 'Sales Channel', code: 'sales_channel_name' },
          { id: 265, name: 'Staff Name', code: 'by_staff' },
          { id: 47, name: 'Payment Method', code: 'by_tender_type' },
        ],
      },
      {
        type: 'Address Location',
        dimensions: [
          { id: 165, name: 'Billing City', code: 'by_city' },
          { id: 164, name: 'Billing State', code: 'by_state' },
          { id: 163, name: 'Billing Country', code: 'by_country' },
          { id: 239, name: 'Shipping City', code: 'by_shipping_city' },
          { id: 240, name: 'Shipping State', code: 'by_shipping_state' },
          { id: 187, name: 'Shipping Country', code: 'by_shipping_country' },
          { id: 189, name: 'Shipping Postcode', code: 'by_shipping_postcode' },
        ],
      },
      {
        type: 'Order Attribute',
        dimensions: [
          { id: 203, name: 'Discount code', code: 'by_discount_code' },
          { id: 130, name: 'Order Number', code: 'document_no' },
          { id: 271, name: 'Order Value Range', code: 'by_order_value_range' },
          { id: 249, name: 'Order Line Item', code: 'Order Item' },
          { id: 237, name: 'Order Tags', code: 'by_order_tag' },
        ],
      },
      {
        type: 'Product Attributes',
        dimensions: [
          { id: 219, name: 'Variant Option', code: 'by_variant_option' },
          { id: 228, name: 'Product Type & Variant Option 1', code: 'by_product_type_variant_option_1' },
          { id: 229, name: 'Product Type & Variant Option 2', code: 'by_product_type_variant_option_2' },
          { id: 224, name: 'Collection & Variant Option 1', code: 'by_variant_option_collection' },
          { id: 227, name: 'Collection & Variant Option 2', code: 'by_collection_variant_option_2' },
          { id: 222, name: 'Vendor & Variant Option 1', code: 'by_variant_option_vendor' },
          { id: 225, name: 'Vendor & Variant Option 2', code: 'by_vendor_variant_option_2' },
          { id: 223, name: 'Location & Variant Option 1', code: 'by_variant_option_location' },
          { id: 226, name: 'Location & Variant Option 2', code: 'by_location_variant_option_2' },
          { id: 241, name: 'Product Properties', code: 'product_properties' },
          { id: 162, name: 'Product Tags', code: 'by_product_tag' },
        ],
      },
    ];
    this.getDimensionListSelectingMeasure();
  }

  public getDimensionListSelectingMeasure() {
    if (!this.measure.code) {
      this.selectingDimensions = this.popularDimensions;
      return;
    }

    const dimensionList: any = [];
    for (const group of this.popularDimensions) {
      const newGroup: any = { type: group.type, dimensions: [] };
      for (const d1 of group.dimensions) {
        for (const d2 of this.measure.dimensions.items) {
          if (d1.code === d2.code) {
            newGroup.dimensions.push(d1);
            break;
          }
        }
      }
      if (newGroup.dimensions.length > 0) {
        dimensionList.push(newGroup);
      }
    }
    this.selectingDimensions = dimensionList;
  }

  public sendMixPanelEvent(name: string = '', data: any = {}) {
    try {
      const eventHandler = new EventHandler({
        store: this.store,
      });
      data.measure = this.measure.code;
      data.dimension = this.dimension.code;
      eventHandler.track(name, data);
    } catch (e) {
      // ignore this
    }
  }

  public showDrilldownDataTable(code: any) {
    this.dialogDrilldown = false;
    if (code) {
      for (const dimension of this.measure.dimensions.items) {
        if (dimension.code === code) {
          this.selectedDrilldownDimension = dimension;
          this.dialogDrilldownDatatable = true;
          this.sendMixPanelEvent('Show drilldown table report', {drilldownDimension: code});
        }
      }
      this.loadSavedReportColumnsFromTemplate();
    }
  }

  public viewLink(link: any) {
    if (link) {
      this.$router.push(link);
    } else {
      this.$router.push('/reports');
    }
  }

  public drilldown(row: any) {
    try {
      const eventHandler = new EventHandler({
        store: this.store,
      });
      eventHandler.track(`Show drilldown dialog`, {
        measure: this.measure.code,
        dimension: this.dimension.code,
      });
    } catch (e) {
      // ignore this
    }
    let data: any;
    this.drilldownFilterColumns = new FilterColumnList();
    for (const filter of this.filterColumns.items) {
      if (filter.code && filter.code !== undefined) {
        data = {
          name: filter.name,
          code: filter.code,
          value: filter.value,
          operator: filter.operator,
          dataType: filter.dataType,
        };
        this.drilldownFilterColumns.add(new FilterColumnModel(data));
      }

    }
    for (const fieldCode of Object.keys(row)) {
      for (const column of this.report.columns) {
        if (column.code === fieldCode) {
          if (column.dataType === 'text' || column.dataType === 'date') {
            let duplicate = false;
            for (const fc of this.drilldownFilterColumns.items) {
              if (fc.code === column.code) {
                duplicate = true;
              }
            }
            if (!duplicate) {
              if (row[fieldCode] !== 'N/A' && row[fieldCode] !== '-') {
                data = {
                  name: column.name,
                  code: column.code,
                  value: [row[fieldCode]],
                  operator: 'eq',
                  dataType: column.dataType,
                };
                this.drilldownFilterColumns.add(new FilterColumnModel(data));
              }
            }
          }
        }
      }
    }
    this.drilldownItem = row;
    this.dialogDrilldown = true;
  }

  public isNameExist(v: any) {
    return !!v || 'Please enter your name!';
  }

  @Watch('selectedReportColumns', { immediate: true, deep: true })
  private async selectedReportColumnsChanged(newVal: any, oldVal: any) {
    // --- ADD THIS CHECK ---
    if (this.isPinning) {
        return;
    }
    // --- END CHECK ---

    // Guard clauses
    if (!this.report || !this.report.columns || this.report.columns.length === 0) {
      return;
    }
    // This check prevents running on initial load if selectedReportColumns starts empty and gets populated later
    // It ensures we only run when the selection *changes* or is initially set with data.
    // if (!newVal || newVal.length === 0) { 
    //   return; // Don't run if the new selection is empty
    // }
    if (this.selectedReportColumns && this.selectedReportColumns.length > 0) {
      this.reload(false);
    }
  }

  public buildCompositionHeaders() {
    let selectedReportColumns: any = this.selectedReportColumns;
    if (!selectedReportColumns || selectedReportColumns.length === 0) {
      selectedReportColumns = this.report.columns.map((c: any) => ({ code: c.code, name: c.name }));
    }

    // --- START Refactored buildCompositionHeaders ---
    let newHeaders: Header[] = [];
    const processedConstituentCodes = new Set<string>();
    let currentPinCount = 0;

    // Create maps needed by helpers
    const allColumnDefsMap = new Map<string, any>();
    this.report.columns.forEach((c: any) => allColumnDefsMap.set(c.code, c));
    const selectedColumnDefs = new Map<string, any>();
    selectedReportColumns.forEach((sc: any) => {
        const def = allColumnDefsMap.get(sc.code);
        if (def) {
            selectedColumnDefs.set(sc.code, def);
        }
    });

    // --- START: Step 1: Identify Dimension Column ---
    let dimensionColumnCode: string | null = null;
    if (this.dimension && this.dimension.code) {
      for (const column of this.report.columns) {
        // Use luisMapping to find the column representing the dimension
        if (column.luisMapping === this.dimension.code) {
          dimensionColumnCode = column.code;
          break;
        }
      }
      // Fallback: Check if dimension.code directly matches a column code
      // (Less likely based on current understanding, but a safe check)
      if (!dimensionColumnCode && allColumnDefsMap.has(this.dimension.code)) {
        dimensionColumnCode = this.dimension.code;
      }
    }
    // --- END: Step 1: Identify Dimension Column ---

    // Call helpers in sequence
    currentPinCount = this._addActionsHeader(newHeaders, currentPinCount);

    // --- START: Refactor Step 2: Call new helper function ---
    // Define allowedKeys BEFORE calling the helper that needs it
    const allowedKeys = getAvailableCompositionKeys(this.measure.code);
    currentPinCount = this._addPrioritizedDimensionHeader(
      newHeaders,
      dimensionColumnCode,
      allowedKeys,
      selectedColumnDefs,
      allColumnDefsMap,
      processedConstituentCodes,
      currentPinCount
    );
    // --- END: Refactor Step 2: Call new helper function ---

    // clone the newHeaders array
    const newHeadersClone = newHeaders.map((header: any) => ({ ...header }));

    // --- START: Identify Main Metric Column (Implementation Plan Step 1) ---
    let mainMetricColumnCode: string | null = null;
    if (this.measure && this.measure.code && this.report && this.report.columns) {
      for (const column of this.report.columns) {
        if (column.luisMapping === this.measure.code) {
          mainMetricColumnCode = column.code;
          break; // Found the main metric column
        }
      }
    }
    
    // --- END: Identify Main Metric Column ---
    // --- START: Call Metric Prioritization Helper ---
    currentPinCount = this._addPrioritizedMetricHeader(
      newHeaders,
      mainMetricColumnCode, // Pass the identified metric code
      allowedKeys,
      selectedColumnDefs,
      allColumnDefsMap,
      processedConstituentCodes,
      currentPinCount
    );
    // --- END: Call Metric Prioritization Helper ---
    // clone the newHeaders array
    const newHeadersClone2 = newHeaders.map((header: any) => ({ ...header }));
    
    // Pass updated pin count and processed codes to subsequent helpers
    // Note: allowedKeys was already defined before the refactored block
    // const allowedKeys = getAvailableCompositionKeys(this.measure.code); // REMOVE duplicate definition
    currentPinCount = this._addPredefinedCompositionHeaders(newHeaders, allowedKeys, selectedColumnDefs, processedConstituentCodes, currentPinCount);

    const pivotGroups = this._groupAndSortPivotColumns(selectedReportColumns, selectedColumnDefs);
    currentPinCount = this._addDynamicPivotHeaders(newHeaders, pivotGroups, processedConstituentCodes, currentPinCount);

    

    currentPinCount = this._addAdditionalInfoHeader(newHeaders, selectedReportColumns, selectedColumnDefs, processedConstituentCodes, currentPinCount);

    // --- START: Final Reordering for Product Info ---
    const actionsIndex = newHeaders.findIndex(h => h.value === 'actions');
    const productInfoIndex = newHeaders.findIndex(h => h.value === 'productInfo');

    // If both headers exist and Product Info is not already right after Actions
    if (actionsIndex !== -1 && productInfoIndex !== -1 && productInfoIndex !== actionsIndex + 1) {
        // Remove Product Info header from its current position
        const [productInfoHeader] = newHeaders.splice(productInfoIndex, 1);
        
        // Calculate the correct insertion index (which might have changed after splice)
        // Re-find actionsIndex just in case, though it should be stable if productInfoIndex > actionsIndex
        const currentActionsIndex = newHeaders.findIndex(h => h.value === 'actions'); 
        const insertAtIndex = currentActionsIndex + 1;
        
        // Insert Product Info header right after Actions
        newHeaders.splice(insertAtIndex, 0, productInfoHeader);
    }
    // --- END: Final Reordering for Product Info ---

    // Assign final headers
    this.headers = newHeaders;
    // --- END Refactored buildCompositionHeaders ---
  }

  public buildStandardHeaders() {
    let selectedReportColumns: any = this.selectedReportColumns;
    if (!this.selectedReportColumns || this.selectedReportColumns.length === 0) {
      selectedReportColumns = this.report.columns;
    }

    this.headers = [
      {
        text: 'Actions',
        value: 'actions',
        class: 'table-header',
        cellClass: 'table-item font-weight-regular',
        sortable: false,
        align: 'center d-print-none',
        isPin: true && !this.isBasicTable,
        left: 0
      }
    ];

    let defaultPinCount = 1; // Start after Actions column if Actions is always pinned
    for (const item of selectedReportColumns) {
      for (const c of this.report.columns) {
        if (c.code === item.code) {
          this.headers.push({
            text: c.name,
            value: c.code,
            class: 'table-header',
            cellClass: 'table-item font-weight-regular',
            sortable: c.sortable,
            description: c.description,
            colorIndex: c.colorIndex,
            dataType: c.dataType,
            isPin: defaultPinCount < this.pinColumnCount && !this.isBasicTable, // Keep !isBasicTable check consistent
            left: 0
          });
          defaultPinCount++;
          break;
        }
      }
    }
    this.reorderHeaders();
  }

  public reload(needGenerateReportColumns: boolean = true) {
    if (!this.report || !this.report.rows) {
      return;
    }
    if (needGenerateReportColumns) {
      this.generateReportColumns();
    }
    if (this.report.rows.length === 0) {
      // If there are no rows, still build headers based on selected columns/mode
      // This prevents the table from showing no headers if the first data load is empty.
       if (this.tableViewMode === 'composition') {
          this.buildCompositionHeaders();
       } else {
          this.buildStandardHeaders();
       }
       this.rows = []; // Ensure rows are empty
       return; // Exit early
    }

    // Build Headers based on View Mode FIRST
    if (this.tableViewMode === 'composition') {
      this.buildCompositionHeaders();
    } else {
      this.buildStandardHeaders();
    }

    this.rebuildRowsData();
  }

  public rebuildRowsData() {
    this.rows = [];
    // reset rows
    this.rows = [];
    for (const index in this.report.rows) {
      if (this.report.rows[index]) {
        const res: any = {};
        for (const column of this.report.columns) {
          if (!this.isSelectedColumn(column.code)) {
            continue;
          }
          if (column.values[index]) {
            res[column.code] = column.values[index];
          } else {
            if ([
              'number',
              'decimal',
              'currency',
              'percent'
            ].includes(column.dataType)) {
              res[column.code] = '0';
            } else {
              res[column.code] = '-';
            }
          }
          // if (column.originalValues[index] === null && column.sortable === false) {
          //   res[column.code] = '';
          // }
        }
        this.rows.push(res);
      }
    }
  }


  public getTableCellClass(header: any, index: number) {
    let cellClass = '';
    if (header.value === 'actions') {
      cellClass += ' data-table-cell-actions d-print-none';
    } else {
      cellClass += ' data-table-cell';
    }

    // Add specific class for image column for styling
    if (header.dataType === 'image') {
      cellClass += ' image-column-cell';
    }

    // Add classes for vertical alignment based on composition type
    if (header.dataType === 'composition') {
      cellClass += ' composition-td'; // General class for all composition cells
      if (header.value === 'productInfo') {
         cellClass += ' product-info-td'; // Specific class for product info
      }
    }

    if (header.isPin) {
      cellClass += ' pinned-column';
      cellClass += ` pin-column${this.getPinnedColumnIndex(header)}`;
      if (this.isLastPinnedColumn(header)) {
        cellClass += ' last-pinned-column';
      }
    }

    return cellClass;
  }

  public getTableHeadCellClass(header: any, index: number) {
    let cellClass = '';
    if (header.value === 'actions') {
      cellClass += 'data-table-cell-actions d-print-none';
    } else {
      cellClass += 'data-table-cell';
    }

    // Add specific class for image column for styling
    if (header.dataType === 'image') {
      cellClass += ' image-column-cell';
    }

    if (header.isPin) {
      cellClass += ' pinned-column';
      cellClass += ` pin-column${this.getPinnedColumnIndex(header)}`;
      if (this.isLastPinnedColumn(header)) {
        cellClass += ' last-pinned-column';
      }
    } else {
      cellClass += ' fix-header';
    }

    return cellClass;
  }

  public getPinnedColumnIndex(header: Header): number {
    return this.headers.filter(h => h.isPin).indexOf(header) + 1;
  }

  public get getPinedHeaders() {
    return this.headers.filter((header: any) => header.isPin);
  }

  public get getUnPinedHeaders(){
    return this.headers.filter((header: any) => !header.isPin);
  }

  public isSelectedColumn(code: string) {
    if (!this.selectedReportColumns || this.selectedReportColumns.length === 0) {
      return true;
    }
    for (const c of this.selectedReportColumns) {
      if (c.code === code) {
        return true;
      }
    }
    return false;
  }

  public resetOptions() {
    if (this.isCreated) {
      this.isResetOptions = true;
      this.page = 1;
      this.perPage = this.options.itemsPerPage;
      this.options = {};
      this.options.sortBy = this.sortBy;
      this.options.sortDesc = this.sortDesc;
    }
  }

  public resetSortOptions() {
    if (this.isCreated) {
      this.sortBy = [];
      this.sortDesc = [];
    }
  }

  public saveReportHeaders() {
    this.$emit('save-report-headers', this.headers);
  }

  public generateReportColumns() {
    const reportColumns: any = [];
    const reportColumnList: any = [];
    if (this.report && this.report.columns && this.report.columns.length > 0) {
      for (const c of this.report.columns) {
        reportColumns.push({
          name: c.name,
          code: c.code,
          dataType: c.dataType,
          luisMapping: c.luisMapping,
          autoSelect: c.autoSelect,
          colorIndex: c.colorIndex,
          sortable: c.sortable,
        });
      }
    }
    if (this.report && this.report.columnList && this.report.columnList.length > 0) {
      for (const c of this.report.columnList) {
        reportColumnList.push({
          name: c.name,
          code: c.code,
          dataType: c.dataType,
          luisMapping: c.luisMapping,
          autoSelect: c.autoSelect,
          colorIndex: c.colorIndex,
          sortable: c.sortable,
        });
      }
    }
    this.$emit('update-report-column', {reportColumns, reportColumnList});

  }

  public getDownloadExcelFileName() {
    let fileName: string;
    fileName = `${this.measure.name.split(' ').join('_').split('-').join('_')}`;
    fileName += `_group_by_${this.dimension.name.split(' ').join('_').split('-').join('_')}`;
    if (this.filterTimerange.length > 1) {
      fileName += `_from_${this.filterTimerange[0].split(' ').join('_').split('-').join('_')}`;
      fileName += `_to_${this.filterTimerange[1].split(' ').join('_').split('-').join('_')}`;
    }
    return fileName;
  }

  public prepareDataExcel() {
    let data: any[];
    data = [];
    for (const row of this.rows) {
      let items: any;
      items = {};
      for (const col of this.headers) {
        if (col.text === 'Actions') {
          continue;
        }
        if (col.text && col.value) {
          items[col.text] = row[col.value];
        }
      }
      data.push(items);
    }
    return data;
  }

  public loadSavedReportColumnsFromTemplate() {
    if (this.store.currentPackage.name !== 'Free') {
      return;
    }
    this.selectedDrilldownReportColumns = [];
    for (const report of this.templateReports.items) {
      if (this.measure.code === report.measure.code &&
        this.selectedDrilldownDimension.code === report.dimension.code) {
        if (report.reportColumns && report.reportColumns.length > 0) {
          this.selectedDrilldownReportColumns = report.reportColumns;
        }
      }
    }
  }

  public reportWrongData() {
    const reportUrl: string = `https://admin.shopify.com/store/${this.store.shopName.split('.')[0]}/apps/${process.env.VUE_APP_NAME}` + this.$route.fullPath;
    let message: string = 'This report is wrong: ' + reportUrl + '.\n';
    message = message + this.wrongDataMessage;
    this.openChat(message);
    this.dialogReportWrongData = false;
  }
  public openChat(openChatMessage: string) {
    // @ts-ignore: Unreachable code error
    this.$crisp.do('chat:open');
    // @ts-ignore: Unreachable code error
    // this.$crisp.do('message:send', ['text', this.$t(`chat_with_us.${this.defaultMessage}`)]);
    this.$crisp.do('message:send', ['text', openChatMessage]);
  }

  public isOptionsChanged() {
    if (this.page !== this.options.page) {
      return true;
    }

    if (this.perPage !== this.options.itemsPerPage) {
      return true;
    }

    if (this.options.sortBy
      && this.options.sortBy.length
      && this.sortBy
      && this.sortBy.length > 0
      && this.options.sortBy.length !== this.sortBy.length
    ) {
      return true;
    }

    if (this.options.sortDesc
      && this.options.sortDesc.length > 0
      && this.sortDesc 
      && this.sortDesc.length > 0
      && this.sortDesc.length !== this.options.sortDesc.length
    ) {
      return true;
    }

    if (this.options.sortDesc 
      && this.sortDesc 
      && this.options.sortDesc.length === this.sortDesc.length
    ) {
      for (let index = 0; index < this.options.sortDesc.length; index++) {
        if (this.options.sortDesc[index] !== this.sortDesc[index]) {
          return true;
        }
      }
    }

    if (this.options.sortBy 
      && this.sortBy 
      && this.options.sortBy.length === this.sortBy.length
    ) {
      for (let index = 0; index < this.options.sortDesc.length; index++) {
        if (this.options.sortBy[index] !== this.sortBy[index]) {
          return true;
        }
      }
    }

    return false;
  }

  public async optionChanged() {
    this.page = this.options.page;
    this.perPage = this.options.itemsPerPage;
    this.sortBy = this.options.sortBy;
    this.sortDesc = this.options.sortDesc;
    this.$emit('update-report-option', this.options);
    this.tableLoading = true; // Set to true
    this.rows = [];

    try {
      if (this.isCreated) {
        await this.getData(); // Base class method likely sets this.isLoading
      } else {
        await this.getReport(); // Base class method likely sets this.isLoading
      }
      // Ensure tableLoading is false after successful data fetch
      this.tableLoading = false; 
    } catch (error: any) {
      // Also ensure tableLoading is false on error
      this.tableLoading = false; 
      // Let the base class handler deal with this.isLoading / this.error
      // console.error("Error during optionChanged data fetch:", error);
      // Re-throw or handle as appropriate, maybe set this.errorData = true
      throw (error);
    } 
    // Removed redundant this.tableLoading = false here, handled in try/catch
  }


  public handleDownloadMessage(event: { type: string; message: string }) {
    EventBus.$emit('show-snackbar', {
      message: event.message,
      color: event.type === 'error' ? 'error' : 'success',
    });
  }

  public async download(emails: any[], selectedDriveFolder: string, downloadName: string = '') {
    this.report.downloadFileExt = this.downloadFileExt;
    this.report.measure = this.measure;
    this.report.dimension = this.dimension;
    this.report.analyticsType = this.analyticsType;
    this.report.filterTimerange = this.filterTimerange;
    this.report.filterColumns = this.filterColumns;
    this.report.reportParams = this.reportParams;
    this.report.isDetail = this.isDetail;
    this.report.filterDimensions = this.filterDimensions;
    this.report.pivotOption = this.pivotOption;
    this.report.reportColumns = this.reportColumns;
    if (this.sortBy || this.report.sortBy) {
      this.report.sortBy = this.sortBy;
      this.report.sortDesc = this.sortDesc;
    }
    try {
      const downloadRule = this.store.rules.items.find((item: any) => item.code === 'download_full_data');
      const isDownloadFull = !downloadRule || downloadRule.value !== 'current page';
      await this.report.download(emails, isDownloadFull, selectedDriveFolder, downloadName);
      this.sendMixPanelEvent('download data', {
        fileFormat: this.report.downloadFileExt,
        fullData: isDownloadFull,
        measure: this.measure.code,
        dimension: this.dimension.code,
      });
      // Flow C: Delayed review ask after download success
      postUnlockReviewService.checkAndTriggerReview(this.store.id, 'download_full_data');
      // Message is now handled by DownloadFullData component via @show-message event
      // EventBus.$emit('show-snackbar', {
      //   message: 'The report is being prepared and will be sent to your email shortly.',
      //   color: 'success',
      // });
    } catch (error: any) {
      // show error message
      EventBus.$emit('show-snackbar', {
        message: error.message,
        color: 'error',
      });
    }
  }

  public getPurchaseOrderReportColumns() {
    const columns: any = [];
    const columnCodes: any = [
      'Item[Item Description]',
      'variant',
      'product_sku',
      'Vendor Name',
      '[inventory_replenishment]',
      '[replenishment_inventory_cost]',
    ];
    for (const column of this.filterReportColumns) {
      if (columnCodes.includes(column.code)) {
        columns.push(column);
      }
    }
    return columns;
  }

  public async generatePurchaseOrder(emails: any[], selectedDriveFolder: string, downloadName: string = '') {
    const report: ReportModel = new ReportModel();
    report.downloadFileExt = this.downloadFileExt;
    report.measure = this.measure;
    report.dimension = this.dimension;
    report.analyticsType = this.analyticsType;
    report.filterTimerange = this.filterTimerange;
    report.filterColumns = this.filterColumns;
    report.reportParams = this.reportParams;
    report.isDetail = this.isDetail;
    report.filterDimensions = this.filterDimensions;
    report.pivotOption = this.pivotOption;
    report.reportColumns = this.getPurchaseOrderReportColumns();
    if (this.sortBy) {
      report.sortBy = this.sortBy;
      report.sortDesc = this.sortDesc;
    }
    try {
      const downloadRule = this.store.rules.items.find((item: any) => item.code === 'download_full_data');
      const isDownloadFull = !downloadRule || downloadRule.value !== 'current page';
      await report.download(emails, isDownloadFull, selectedDriveFolder, downloadName);
      this.sendMixPanelEvent('generate purchase order', {
        fileFormat: this.downloadFileExt,
        measure: this.measure.code,
        dimension: this.dimension.code,
      });
      EventBus.$emit('show-snackbar', {
        message: 'The purchase order is being prepared and will be sent to your email shortly.',
        color: 'success',
      });
    } catch (error: any) {
      // show error message
      EventBus.$emit('show-snackbar', {
        message: error.message,
        color: 'error',
      });
    }
  }

  public updateDownloadFileExt(fileExt: string) {
    this.downloadFileExt = fileExt;
  }

  @Watch('initOptions', { immediate: true, deep: true })
  private async initOptionsChanged(newVal: any, oldVal: any) {
    if (this.initOptions) {
      // Always update options when initOptions changes, not just when sortBy exists
      this.options = { ...this.initOptions };
    }
  }

  @Watch('options', { immediate: true, deep: true })
  private async optionsChanged(newVal: any, oldVal: any) {
    if (this.fisrtTimeInitOption) {
      this.fisrtTimeInitOption = false;
      return;
    }
    if (this.isResetOptions) {
      this.isResetOptions = false;
      return;
    }
    if (this.isOptionsChanged()) {
      this.optionChanged();
    }
  }

  public getRowClass(item: any) {
    const rules = this.colorRules;
    const color = rules.evaluateRow(item, this.measure.code);
    if (color && color.coloringType === 'row') {
      return { 'background-color': color.color };
    }
    return {};
  }

  public getCellClass(item: any, header: Header) {
    const rules = this.colorRules;

    // First check for row-level coloring
    const rowColor = rules.evaluateRow(item, this.measure.code);
    if (rowColor && rowColor.coloringType === 'row') {
      return { 'background-color': rowColor.color };
    }

    // Then check for cell-level coloring
    const cellColor = rules.evaluateCell(item, header.value, this.measure.code);
    if (cellColor) {
      return { 'background-color': cellColor };
    }

    return {};
  }

  public togglePinColumn(header: Header) {
    this.isPinning = true; // Set flag before changes
    header.isPin = !header.isPin;
    this.reorderHeaders(); // Reorders the this.headers array

    const pinColumnCount = this.headers.filter(h => h.isPin).length;
    // Emit uses the corrected getSelectedReportColumnsWithOrder
    this.$emit('update-pin-state', {updatedColumns: this.getSelectedReportColumnsWithOrder(), pinColumnCount: pinColumnCount});

    // Explicitly wait for the next DOM update cycle before calculating offsets
    this.$nextTick(() => {
      this.updatePinnedColumnOffsets();
      // --- RESET FLAG HERE ---
      // Use another $nextTick to ensure it resets AFTER the watcher potentially runs
      this.$nextTick(() => {
         this.isPinning = false;
      });
      // setTimeout(() => { this.isPinning = false; }, 0); // Alternative reset
    });
  }

  public reorderHeaders() {
    // Separate pinned and unpinned headers
    const pinnedHeaders = this.headers.filter(h => h.isPin);
    const unpinnedHeaders = this.headers.filter(h => !h.isPin);

    // Combine them back together with pinned headers first
    this.headers = [...pinnedHeaders, ...unpinnedHeaders];
  }

  public getSelectedReportColumnsWithOrder() {
    const pinnedHeaders = this.headers.filter(h => h.isPin);
    const pinnedOriginalCodes = new Set<string>();

    // Add codes from pinned standard headers AND constituent codes from pinned composition headers
    pinnedHeaders.forEach(header => {
        if (header.dataType === 'composition') {
            const config = this.getCompositionConfigForKey(header.value);
            if (config) {
                // Add all constituent codes of this pinned composition
                config.constituentCodes.forEach(code => {
                    // Only add if the constituent was actually selected initially
                    if (this.selectedColumnCodesSet.has(code)) { // Use the existing Set for efficiency
                        pinnedOriginalCodes.add(code);
                    }
                });
            }
        } else {
            // It's a standard header, add its code directly if it was selected
             if (this.selectedColumnCodesSet.has(header.value)) {
                pinnedOriginalCodes.add(header.value);
             }
        }
    });

    // Now filter selectedReportColumns based on the comprehensive set of pinned original codes
    const pinnedColumns = this.selectedReportColumns.filter((c: any) => pinnedOriginalCodes.has(c.code));
    const unpinnedColumns = this.selectedReportColumns.filter((c: any) => !pinnedOriginalCodes.has(c.code));

    // Order: Pinned columns first, then unpinned columns.
    // Maintain relative order within pinned/unpinned groups for now.
    // More sophisticated ordering based on this.headers might be needed if exact order matching parent state is critical.
    const newSelectedReportColumns = [...pinnedColumns, ...unpinnedColumns];
    return newSelectedReportColumns;
  }

  public getColumnWidth(header: Header): number {
    switch (header.value) {
      case 'actions':
        return 56; // Fixed width for actions column
      default:
        return 220; // Default width for other columns
    }
  }

  public isLastPinnedColumn(header: Header): boolean {
    const pinnedHeaders = this.headers.filter((h: any) => h.isPin);
    return pinnedHeaders[pinnedHeaders.length - 1]?.value === header.value;
  }

  public openColumnSelector() {
    EventBus.$emit('open-column-selector');
    this.sendMixPanelEvent('Open Column Selector', {
      source: 'table_header_button'
    });
  }

  public parseListData(value: string): string[] {
    if (!value || value === '-') return ['-'];
    
    // Remove brackets from the string
    const cleanStr = value.replace(/^\[|\]$/g, '');
    
    // Split by comma and clean up each item
    return cleanStr
      .split(',')
      .map(item => item.trim())
      .filter(item => item.length > 0);
  }

  private emitLoadingState() {
    // Avoid emitting loading state if there's an error shown in the table
    if (this.errorData) { 
      return;
    }
    if (this.isCreated) {
      const combinedLoading = this.isLoading || this.tableLoading;
      this.$emit('loading-state-changed', combinedLoading);
    }
  }

  @Watch('tableLoading')
  private onTableLoadingChanged() {
    this.emitLoadingState();
  }

  @Watch('isLoading')
  private onIsLoadingChanged() {
    this.emitLoadingState();
  }

  // --- ADDITIONS FOR PHASE 4 ---
  /**
   * Simple debounce utility function.
   */
  private debounce(func: Function, wait: number): Function {
    let timeout: number | null = null;
    return (...args: any[]) => {
      const later = () => {
        timeout = null;
        func.apply(this, args);
      };
      if (timeout !== null) {
        clearTimeout(timeout);
      }
      timeout = window.setTimeout(later, wait);
    };
  }

  /**
   * Calculates and applies 'left' style to pinned columns based on actual width.
   * Populates dTotalOffsets prop for DTotal component.
   */
  public updatePinnedColumnOffsets(): void {
    // Use nextTick *inside* the function to ensure DOM is ready for queries
    this.$nextTick(() => {
      // Ensure the table body exists and we are in the browser context
      if (typeof window === 'undefined' || !this.$el || !this.$el.querySelector) {
          return;
      }

      const tableWrapper = this.$el.querySelector('.v-data-table__wrapper') as HTMLElement;
      if (!tableWrapper) {
          return;
      }

      const headerRow = tableWrapper.querySelector('thead > tr') as HTMLTableRowElement;
      // Query ONLY regular data rows now
      const dataTableRows = tableWrapper.querySelectorAll('tbody > tr.data-table-row') as NodeListOf<HTMLTableRowElement>;
      // --- START: Corrected DTotal row selector ---
      const dTotalRow = tableWrapper.querySelector('tbody > tr.d-total-row') as HTMLTableRowElement | null;
      // --- END: Corrected DTotal row selector ---

      if (!headerRow) {
          return;
      }

      // Get pinned headers in their current DOM order
      const pinnedHeaders = Array.from(headerRow.querySelectorAll('th.pinned-column')) as HTMLElement[];

      let cumulativeOffset = 0;
      const newOffsets: { [index: number]: string } = {}; // Temporary object for reactivity

      pinnedHeaders.forEach((th, headerIndex) => {
          const currentOffsetPx = `${cumulativeOffset}px`;

          // Apply the calculated offset to the header
          th.style.left = currentOffsetPx;

          // Apply the same offset to the corresponding data cells in each DATA TABLE row
          dataTableRows.forEach(row => {
              const cells = row.querySelectorAll('td'); // Get all cells in the row
              if (cells.length > headerIndex) {
                 const td = cells[headerIndex] as HTMLElement;
                 // Ensure the cell is actually meant to be pinned
                 const isPinned = td && td.classList.contains('pinned-column');
                 if (isPinned) {
                      td.style.left = currentOffsetPx;
                   }
              }
          });

          // --- START: Apply offset to DTotal row cells ---
          if (dTotalRow) {
            const dTotalCells = dTotalRow.querySelectorAll('td');
            if (dTotalCells.length > headerIndex) {
              const dTotalTd = dTotalCells[headerIndex] as HTMLElement;
              // Check if the DTotal cell should be pinned (assuming it mirrors header pinning)
              // This relies on DTotal correctly adding the 'pinned-column' class
              const isPinned = dTotalTd && dTotalTd.classList.contains('pinned-column');
              if (isPinned) {
                dTotalTd.style.left = currentOffsetPx;
              }
            }
          }
          // --- END: Apply offset to DTotal row cells ---

          // Store the offset for DTotal (this part remains the same, affects DTotal's internal logic if it uses dTotalOffsets)
          newOffsets[headerIndex] = currentOffsetPx;

          // Measure the actual width of the header cell for the next offset
          // Ensure the element exists before getting bounding rect
          if (th) {
              const width = th.getBoundingClientRect().width;
              cumulativeOffset += width;
          }
      });

      // Assign the new object to the reactive property
      this.dTotalOffsets = newOffsets;
    }); // End of this.$nextTick wrapper
  }
  
  // --- END ADDITIONS ---

  // --- MODIFICATIONS FOR PHASE 4 ---
  // Ensure mounted, updated, beforeDestroy exist and add the logic
  public mounted(): void {
    // Initialize debounced function
    this.debouncedUpdateOffsets = this.debounce(this.updatePinnedColumnOffsets, 150); 

    // Add resize listener
    window.addEventListener('resize', this.debouncedUpdateOffsets as EventListener);

    // Initial calculation after mount, with a slight delay for layout stabilization
    this.$nextTick(() => {
      setTimeout(() => {
        this.updatePinnedColumnOffsets();
      }, 250); // Increased delay to 250ms
    });

    // ... any existing mounted logic should be preserved ...
  }

  public updated(): void {
    // Recalculate after DOM updates
    this.$nextTick(() => {
      this.updatePinnedColumnOffsets();
    });
     // ... any existing updated logic should be preserved ...
  }

  public beforeDestroy(): void {
     // Clean up resize listener
    window.removeEventListener('resize', this.debouncedUpdateOffsets as EventListener);
     // ... any existing beforeDestroy logic should be preserved ...
  }

  // Watchers to trigger updates when relevant data changes
  @Watch('headers', { deep: true }) // Watch headers array changes
  @Watch('rows')    // Watch row data changes (might affect widths)
  @Watch('pinColumnCount') // Watch if the number of pinned columns changes
  private onDataOrPinChange() {
      // Use nextTick to ensure DOM is updated before measuring
      this.$nextTick(() => {
          this.updatePinnedColumnOffsets();
      });
  }
  // --- END MODIFICATIONS ---

  // WATCHER FOR TABLE VIEW MODE CHANGE
  @Watch('tableViewMode')
  private onTableViewModeChanged() {
    // Call the existing method that handles header and row regeneration
    // based on selected columns and now also the view mode.
    this.reload(false);
  }

  // --- START PLACEHOLDER FORMATTERS ---
  public formatPercentage(value: any): string {
    try {
      // Basic placeholder: Add a % symbol. Replace with actual helper later.
       if (value === null || value === undefined || value === '-') return '-';
      const num = parseFloat(value);
      if (isNaN(num)) return String(value);
      // Assuming the input is already a percentage value (e.g., 15.5 for 15.5%)
      return `${num.toFixed(1)}%`; 
    } catch (error) {
      console.error("Error formatting percentage:", value, error);
      return '-'; // Default on error
    }
  }

  public formatNumber(value: any, decimalPlaces: number = 0): string {
     try {
      // Basic placeholder: Format number with fixed decimal places. Replace with actual helper later.
       if (value === null || value === undefined || value === '-') return '-';
      const num = parseFloat(value);
      if (isNaN(num)) return String(value);
      return num.toFixed(decimalPlaces);
    } catch (error) {
      console.error("Error formatting number:", value, error);
      return '-'; // Default on error
    }
  }

  // Add formatDate if it doesn't exist
  public formatDate(value: any): string {
    if (!value || value === '-') return '-';
    try {
      // Basic date formatting, adjust format string as needed
      return dateFormat(value, 'mmm d, yyyy', true);
    } catch (error) {
      console.error("Error formatting date:", value, error);
      return String(value); // Return original value on error
    }
  }
  // --- END PLACEHOLDER FORMATTERS ---

  // --- START COMPUTED PROPERTY FOR SELECTED CODES ---
  public get selectedColumnCodesSet(): Set<string> {
    if (!this.selectedReportColumns || this.selectedReportColumns.length === 0) {
      // If no columns are selected, maybe treat all report columns as selected?
      // Or return an empty set? Returning empty set seems safer.
      // return new Set(this.reportColumns.map((c: any) => c.code));
       return new Set<string>(); // Or handle based on desired behavior when empty
    }
    return new Set(this.selectedReportColumns.map((c: any) => c.code));
  }
  // --- END COMPUTED PROPERTY FOR SELECTED CODES ---

  // --- START HELPER FOR CONFIG LOOKUP ---
  public getCompositionConfigForKey(key: string): CompositionDefinition | undefined {
    return compositionConfig[key];
  }
  // --- END HELPER FOR CONFIG LOOKUP ---

  // --- START PIVOT HELPER FUNCTION ---
  public getPivotInfo(headerValue: string): { isPivot: boolean; metric?: string; dimension?: string; value?: string } {
    // --- START: Simplified logic using string splitting --- 
    if (!headerValue) {
      return { isPivot: false };
    }
    // Remove leading '[' and trailing ']'
    const content = headerValue;

    const pivotPerSeparator = '_pivot_per_';
    const pivotSeparator = '_pivot_';
    const pivotPerIndex = content.lastIndexOf(pivotPerSeparator);
    
    // Basic structural check for the separator
    if (pivotPerIndex === -1) {
      return { isPivot: false };
    }

    try {
      // Value is everything after the separator
      const valueWithDimension = content.substring(pivotPerIndex + pivotPerSeparator.length).trim();
      // the value is in this format 2026 Mar (month)
      // now we extract the month as dimension by getting the text between the parentheses
      const dimension = valueWithDimension.substring(valueWithDimension.indexOf('(') + 1, valueWithDimension.indexOf(')')).trim();
      const value = valueWithDimension.substring(0, valueWithDimension.indexOf('(')).trim();
      
      const beforePivotPer = content.substring(0, pivotPerIndex);
      const pivotIndex = beforePivotPer.lastIndexOf(pivotSeparator);
      let metric = '';
      if (pivotIndex !== -1) {
          metric = beforePivotPer.substring(pivotIndex + 7).trim();
      } else {
          // Handle case where there might not be an underscore before the metric
          metric = beforePivotPer.trim(); 
      }
      // remove the special characters from the metric
      metric = metric.replace(/[^\w\s]/g, '');
      
      // Dimension is no longer extracted in this simplified version
      if (value && metric) {
        const pivotGroup = { 
          isPivot: true,
          metric: metric,
          value: value,
          dimension: dimension
        };
        return pivotGroup;
      } else {
         // If parts are empty, treat as unparseable pivot (but still indicate isPivot)
         return { isPivot: true, metric: undefined, value: undefined, dimension: undefined }; 
      }

    } catch (e) {
      console.error("Error parsing pivot header string (simplified):", headerValue, e);
      // Fallback check if unexpected error occurs
       if (content.includes(pivotPerSeparator)) {
        return { isPivot: true, metric: undefined, value: undefined, dimension: undefined }; 
      }
      return { isPivot: false };
    }
    // --- END: Simplified logic using string splitting --- 
  }
  // --- END PIVOT HELPER FUNCTION ---

  // --- START PIVOT GROUPING HELPER ---
  private _groupAndSortPivotColumns(selectedReportColumns: any[], selectedColumnDefs: Map<string, any>): Map<string, { definition: CompositionDefinition, columns: any[] }> {
    const pivotGroups = new Map<string, { definition: CompositionDefinition, columns: any[] }>();
    selectedReportColumns.forEach((selectedCol: any) => {
        const fullColDef = selectedColumnDefs.get(selectedCol.code);
        if (fullColDef) {
            const pivotInfo = this.getPivotInfo(fullColDef.code);
            if (pivotInfo.isPivot && pivotInfo.metric && pivotInfo.dimension) {
                const groupKey = `pivot_${pivotInfo.metric}_${pivotInfo.dimension}`;
                if (!pivotGroups.has(groupKey)) {
                    const capitalize = (s: string) => s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : '';
                    const metricName = capitalize(pivotInfo.metric.replace(/_/g, ' '));
                    const dimensionName = capitalize(pivotInfo.dimension.replace(/_/g, ' '));
                    pivotGroups.set(groupKey, {
                        definition: {
                            compositionName: `${metricName} (by ${dimensionName})`,
                            primaryCode: '',
                            constituentCodes: [],
                        },
                        columns: [],
                    });
                }
                const group = pivotGroups.get(groupKey)!;
                group.columns.push(fullColDef);
                group.definition.constituentCodes.push(fullColDef.code);
            }
        }
    });

    // Sort Pivot Constituents
    pivotGroups.forEach((group) => {
        group.columns.sort((a, b) => a.name.localeCompare(b.name));
        group.definition.constituentCodes = group.columns.map(col => col.code);
    });

    return pivotGroups;
  }
  // --- END PIVOT GROUPING HELPER ---

  // --- START HEADER GENERATION HELPERS ---

  private _addActionsHeader(newHeaders: Header[], currentPinCount: number): number {
    if (!this.isBasicTable) {
        const isPinned = currentPinCount < this.pinColumnCount;
        newHeaders.push({
            text: 'Actions',
            value: 'actions',
            class: 'table-header',
            cellClass: 'table-item font-weight-regular',
            sortable: false,
            align: 'center d-print-none',
            isPin: isPinned,
            left: 0
        });
        if (isPinned) {
            currentPinCount++;
        }
    }
    return currentPinCount;
  }

  private _addDynamicPivotHeaders(newHeaders: Header[], pivotGroups: Map<string, { definition: CompositionDefinition, columns: any[] }>, processedConstituentCodes: Set<string>, currentPinCount: number): number {
    pivotGroups.forEach((group, groupKey) => {
        if (group.columns.length > 1) {
            const isPinned = currentPinCount < this.pinColumnCount && !this.isBasicTable;
            newHeaders.push({
                text: group.definition.compositionName,
                value: groupKey,
                sortable: false,
                isPin: isPinned,
                dataType: 'composition',
                class: 'table-header',
                cellClass: 'table-item font-weight-regular',
                left: 0,
                dynamicConfig: group.definition
            });
            if (isPinned) {
                currentPinCount++;
            }
            group.definition.constituentCodes.forEach(code => {
                processedConstituentCodes.add(code);
            });
        }
    });
    return currentPinCount;
  }

  private _addPredefinedCompositionHeaders(newHeaders: Header[], allowedKeys: string[], selectedColumnDefs: Map<string, any>, processedConstituentCodes: Set<string>, currentPinCount: number): number {
    allowedKeys.forEach(key => {
        const config = compositionConfig[key];
        if (!config) return;

        const selectedNonImageConstituents = config.constituentCodes.filter(code => {
            const def = selectedColumnDefs.get(code);
            return def && def.dataType !== 'image' && !processedConstituentCodes.has(code);
        });

        if (selectedNonImageConstituents.length > 0) {
            const isPinned = currentPinCount < this.pinColumnCount && !this.isBasicTable;
            newHeaders.push({
                text: config.compositionName,
                value: key,
                sortable: false,
                isPin: isPinned,
                dataType: 'composition',
                class: 'table-header',
                cellClass: 'table-item font-weight-regular',
                left: 0,
                dynamicConfig: config
            });
            if (isPinned) {
                currentPinCount++;
            }
            config.constituentCodes.forEach(code => {
                const def = selectedColumnDefs.get(code);
                if (def && def.dataType !== 'image' && !processedConstituentCodes.has(code)) {
                    processedConstituentCodes.add(code);
                }
            });
        }
    });
    return currentPinCount;
  }

  private _addAdditionalInfoHeader(newHeaders: Header[], selectedReportColumns: any[], selectedColumnDefs: Map<string, any>, processedConstituentCodes: Set<string>, currentPinCount: number): number {
    const additionalInfoColumns: any[] = [];
    selectedReportColumns.forEach((selectedCol: any) => {
        const fullColDef = selectedColumnDefs.get(selectedCol.code);
        if (fullColDef && fullColDef.dataType !== 'image' && !processedConstituentCodes.has(selectedCol.code)) {
            additionalInfoColumns.push(selectedCol);
        }
    });

    if (additionalInfoColumns.length > 0) {
        const isPinned = currentPinCount < this.pinColumnCount && !this.isBasicTable;
        const additionalConfig: CompositionDefinition = {
            compositionName: 'Additional Info',
            primaryCode: '',
            constituentCodes: additionalInfoColumns.map(c => c.code)
        };
        newHeaders.push({
            text: 'Additional Info',
            value: 'additionalInfo',
            sortable: false,
            isPin: isPinned,
            dataType: 'composition',
            class: 'table-header',
            cellClass: 'table-item font-weight-regular',
            left: 0,
            dynamicConfig: additionalConfig
        });
        if (isPinned) {
            currentPinCount++;
        }
        additionalInfoColumns.forEach(col => processedConstituentCodes.add(col.code));
    }
    return currentPinCount;
  }

  private _addRemainingStandardHeaders(newHeaders: Header[], selectedReportColumns: any[], selectedColumnDefs: Map<string, any>, processedConstituentCodes: Set<string>, currentPinCount: number): number {
    selectedReportColumns.forEach((selectedCol: any) => {
        const fullColDef = selectedColumnDefs.get(selectedCol.code);
        if (fullColDef && !processedConstituentCodes.has(selectedCol.code)) {
            const isPinned = currentPinCount < this.pinColumnCount && !this.isBasicTable;
            newHeaders.push({
                text: fullColDef.name,
                value: fullColDef.code,
                class: 'table-header',
                cellClass: 'table-item font-weight-regular',
                sortable: fullColDef.sortable,
                description: fullColDef.description,
                colorIndex: fullColDef.colorIndex,
                dataType: fullColDef.dataType,
                isPin: isPinned,
                left: 0
            });
            if (isPinned) {
                currentPinCount++;
            }
        }
    });
    return currentPinCount; // Return final count, though it might not be used after this step
  }

  // --- END HEADER GENERATION HELPERS ---

  // --- START: New Helper for Dimension Prioritization ---
  private _addPrioritizedDimensionHeader(
    newHeaders: Header[],
    dimensionColumnCode: string | null,
    allowedKeys: string[],
    selectedColumnDefs: Map<string, any>,
    allColumnDefsMap: Map<string, any>,
    processedConstituentCodes: Set<string>,
    currentPinCount: number
  ): number {
    if (dimensionColumnCode && selectedColumnDefs.has(dimensionColumnCode)) {
      let dimensionHandled = false;

      // Scenario A: Check if dimension is in a suitable predefined composition
      for (const key of allowedKeys) {
        const config = compositionConfig[key];
        if (config && config.constituentCodes.includes(dimensionColumnCode)) {
          // Check if this composition has OTHER selected, non-image constituents
          const otherSelectedConstituents = config.constituentCodes.filter(code =>
            code !== dimensionColumnCode &&
            selectedColumnDefs.has(code) &&
            selectedColumnDefs.get(code)?.dataType !== 'image'
          );

          if (otherSelectedConstituents.length > 0) {
            // Add this composition header first
            const isPinned = currentPinCount < this.pinColumnCount && !this.isBasicTable;
            newHeaders.push({
              text: config.compositionName,
              value: key,
              sortable: false,
              isPin: isPinned,
              dataType: 'composition',
              class: 'table-header',
              cellClass: 'table-item font-weight-regular',
              left: 0,
              dynamicConfig: config
            });
            if (isPinned) {
              currentPinCount++;
            }
            // Mark all its *selected* constituents as processed
            config.constituentCodes.forEach((code: string) => {
              if (selectedColumnDefs.has(code)) {
                 processedConstituentCodes.add(code);
              }
            });
            dimensionHandled = true;
            break; // Dimension handled, exit loop
          }
        }
      }

      // Scenario B: Dimension is standalone or its composition has no other selected items
      if (!dimensionHandled) {
        const dimensionColDef = allColumnDefsMap.get(dimensionColumnCode);
        if (dimensionColDef) { // Ensure definition exists
            const isPinned = currentPinCount < this.pinColumnCount && !this.isBasicTable;
            newHeaders.push({
                text: dimensionColDef.name,
                value: dimensionColDef.code,
                class: 'table-header',
                cellClass: 'table-item font-weight-regular',
                sortable: dimensionColDef.sortable,
                description: dimensionColDef.description,
                colorIndex: dimensionColDef.colorIndex,
                dataType: dimensionColDef.dataType, // Use its original dataType
                isPin: isPinned,
                left: 0
            });
            if (isPinned) {
                currentPinCount++;
            }
            processedConstituentCodes.add(dimensionColumnCode); // Mark as processed
        }
      }
    }
    return currentPinCount;
  }
  // --- END: New Helper for Dimension Prioritization ---

  // --- START: New Helper for Metric Prioritization ---
  private _addPrioritizedMetricHeader(
    newHeaders: Header[],
    mainMetricColumnCode: string | null,
    allowedKeys: string[],
    selectedColumnDefs: Map<string, any>,
    allColumnDefsMap: Map<string, any>,
    processedConstituentCodes: Set<string>,
    currentPinCount: number
  ): number {
    // 1. Check Validity & Processing
    if (!mainMetricColumnCode || !selectedColumnDefs.has(mainMetricColumnCode) || processedConstituentCodes.has(mainMetricColumnCode)) {
      // Metric code invalid, not selected, or already handled (e.g., by dimension logic)
      return currentPinCount;
    }

    let metricHandled = false;
    const metricColDef = allColumnDefsMap.get(mainMetricColumnCode); // Get metric definition

    if (!metricColDef) {
        // Should not happen if selectedColumnDefs check passed, but safety check
        return currentPinCount;
    }


    // 2. Scenario A: Check if Metric is in a Suitable Predefined Composition
    for (const key of allowedKeys) {
      const config = compositionConfig[key];
      if (config && config.constituentCodes.includes(mainMetricColumnCode)) {
        // Check if this composition header has *already been added* (e.g., because it also contained the dimension)
        const compositionAlreadyAdded = newHeaders.some(header => header.value === key);

        if (!compositionAlreadyAdded) {
           // Check if this composition has OTHER selected, non-image constituents
           const otherSelectedConstituents = config.constituentCodes.filter(code =>
              code !== mainMetricColumnCode &&
              selectedColumnDefs.has(code) &&
              selectedColumnDefs.get(code)?.dataType !== 'image'
            );

            // Only add if the composition is suitable (>1 member generally, or primary metric focus)
            // AND it hasn't been added yet.
            // For metric, we might consider adding even if it's the only selected member of its group
            // if that grouping makes sense (e.g., 'Sales Figures').
            // Let's be slightly more lenient than dimension: add if *any* constituent is selected.
            const anySelectedConstituent = config.constituentCodes.some(code => selectedColumnDefs.has(code));

            if (anySelectedConstituent) {
                const isPinned = currentPinCount < this.pinColumnCount && !this.isBasicTable;
                newHeaders.push({
                    text: config.compositionName,
                    value: key,
                    sortable: false, // Compositions generally aren't sortable directly
                    isPin: isPinned,
                    dataType: 'composition',
                    class: 'table-header',
                    cellClass: 'table-item font-weight-regular',
                    left: 0,
                    dynamicConfig: config // Use the predefined config
                });
                if (isPinned) {
                    currentPinCount++;
                }
                // Mark all its *selected* constituents as processed
                 config.constituentCodes.forEach((code: string) => {
                    if (selectedColumnDefs.has(code)) {
                        processedConstituentCodes.add(code);
                    }
                });
                metricHandled = true;
                break; // Metric handled, exit loop
            }
        } else {
            // Composition was already added (likely contained the dimension).
            // The metric is handled within that existing header.
            // Ensure it's marked processed if not already.
            processedConstituentCodes.add(mainMetricColumnCode);
            metricHandled = true; // Mark as handled
            break;
        }
      }
    }

    // 3. Scenario B: Metric Standalone (Create Single-Item Composition)
    if (!metricHandled) {
      // Create a dynamic config for just this metric
      const metricCompositionConfig: CompositionDefinition = {
        compositionName: metricColDef.name, // Use the metric's actual name
        primaryCode: mainMetricColumnCode,
        constituentCodes: [mainMetricColumnCode],
      };

      const isPinned = currentPinCount < this.pinColumnCount && !this.isBasicTable;
      newHeaders.push({
        text: metricColDef.name, // Header text is metric name
        value: mainMetricColumnCode, // Use metric code as unique value key for this header
        sortable: metricColDef.sortable, // Allow sorting if original metric was sortable
        isPin: isPinned,
        dataType: 'composition', // Treat as composition for rendering
        class: 'table-header',
        cellClass: 'table-item font-weight-regular',
        left: 0,
        dynamicConfig: metricCompositionConfig // Use the dynamic config
      });

      if (isPinned) {
        currentPinCount++;
      }
      processedConstituentCodes.add(mainMetricColumnCode); // Mark as processed
    }

    return currentPinCount;
  }
  // --- END: New Helper for Metric Prioritization ---

}
